import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import CalculationsCheckboxes from 'features/settings/CalculationsCheckboxes';
import DefaultGroupLimitInput from 'features/settings/DefaultGroupLimitInput';
import DeleteLocalStorageButton from 'features/settings/DeleteLocalStorageButton';
import CartSelection from 'features/shoppingCart/CartSelection';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  contentRoot: {
    padding: theme.spacing(2, 2),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  deleteButton: {
    marginTop: theme.spacing(4),
  },
}));

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const Settings = ({ open, setOpen }: Readonly<Props>) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog
      aria-labelledby="modal-title"
      aria-describedby="modal-content"
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="lg"
    >
      <DialogTitle className={classes.root} id="modal-title">
        {t('settings')}
        <IconButton
          className={classes.closeButton}
          aria-label="close"
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.contentRoot} dividers>
        <CalculationsCheckboxes />
        <div>
          <CartSelection />
          <div>
            <DefaultGroupLimitInput />
          </div>
          <div className={classes.deleteButton}>
            <DeleteLocalStorageButton />
          </div>
          <Typography display="block" variant="caption" color="secondary">
            {t('cant_undo_1')}
          </Typography>
          <Typography variant="caption" color="secondary">
            {t('cant_undo_2')}
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Settings;
